module.exports = __webpack_public_path__ + "static/media/newFacebook.cbf19537.svg";